<template>
  <div>
    <div v-if="loading">
      <div class="col-5 m-0 p-0 my-3">
        <b-skeleton class="border-0" width="85%"></b-skeleton>
        <b-skeleton class="border-0" width="45%"></b-skeleton>
      </div>
      <b-row cols="6">
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
      </b-row>
      <div class="col-12 m-0 p-0 my-5">
        <b-skeleton class="border-0" width="60%"></b-skeleton>
        <b-skeleton class="border-0" width="15%"></b-skeleton>
        <b-skeleton class="border-0" width="28%"></b-skeleton>
        <b-skeleton class="border-0" width="88%"></b-skeleton>
      </div>
      <div class="col-12 my-4 m-0 p-0">
        <b-skeleton class="border-0 mb-5" width="28%"></b-skeleton>
        <b-skeleton-table
        class=""
        :rows="10"
        :columns="4"
        :table-props="{ bordered: false, striped: true }"
      ></b-skeleton-table>
      </div>
    </div>
    <div v-else>
    <h6 class="m-0 p-0">Ticket #{{ paymentRetrievalId }}</h6>
    <h6>
      <span
        v-if="paymentRetrievalHistory.status == 1"
        class="badge badge-success"
        >Open</span
      >
      <span
        v-if="paymentRetrievalHistory.status == 0"
        class="badge badge-danger"
        >Closed</span
      >
    </h6>
    <div class="pb-4 m-0 p-0">
      <div class="comment col-12 m-0 p-0">
        <div class="comment-container col-md-12 m-0">
          <b-icon class="img" icon="chat-left-dots"></b-icon>
          <p class="m-0 p-0">{{ paymentRetrievalHistory.comment }}</p>
          <p class="m-0 p-0" style="font-size: 12px; color: gray">
            Ticket opened by {{ paymentRetrievalHistory.agentData.userName }} on
            {{ paymentRetrievalHistory.createdAt | moment("LL") }}
          </p>
        </div>
      </div>
      <div class="payment-details row my-4">
        <div class="col-md-2 text-center">
          <div
            class="card border-0 py-3"
            style="background: #5ba8ff; color: white"
          >
            <p class="m-0 p-0">Total Amount</p>
            <h2>{{ paymentRetrievalHistory.amount | currency}}</h2>
          </div>
        </div>
        <div class="col-md-2 text-center">
          <div
            class="card border-0 py-3"
            style="background: #43dcbd; color: white"
          >
            <p class="m-0 p-0">Balance Amount</p>
            <h2>{{ paymentRetrievalHistory.balance | currency}}</h2>
          </div>
        </div>
        <div class="col-md-2 text-center">
          <div
            class="card border-0 py-3"
            style="background: #ffc167; color: white"
          >
            <p class="m-0 p-0">Waived Off</p>
            <h2>{{ paymentRetrievalHistory.waivedOff | currency}}</h2>
          </div>
        </div>
        <div class="col-md-2 text-center">
          <div
            class="card border-0 py-3"
            style="background: #ff6780; color: white"
          >
            <p class="m-0 p-0">Paid Amount</p>
            <h2>
              {{
                paymentRetrievalHistory.amount -
                (paymentRetrievalHistory.balance +
                  paymentRetrievalHistory.waivedOff) | currency
              }}
            </h2>
          </div>
        </div>
      </div>
      <div class="retrievalPaymentHistory text-right col-md-12 mt-3 m-0 p-0">
        <!-- <h6>Payment History</h6> -->
        <div>
          <b-button variant="primary" @click="adjustPayment()"
            >Update Payment</b-button
          >
        </div>
      </div>
      <div class="customerDetail">
        <!-- <h6 class="m-0 p-0">Customer Details</h6> -->
        <div>
          <h6 class="m-0 p-0">
            {{ paymentRetrievalHistory.customerData.fName }}
            {{ paymentRetrievalHistory.customerData.lName }}
            <!-- <p class="m-0 p-0 mb-2"> -->
            <span
              v-if="paymentRetrievalHistory.customerData.status == 1"
              class="badge badge-success"
              >Active</span
            >
            <span
              v-if="paymentRetrievalHistory.customerData.status == 0"
              class="badge badge-danger"
              >Inactive</span
            >
            <!-- </p> -->
          </h6>
          <a
            class="m-0 p-0"
            style="text-decoration: none"
            :href="'tel:' + paymentRetrievalHistory.customerData.mobile"
          >
            <b-icon icon="phone"></b-icon>
            {{ paymentRetrievalHistory.customerData.mobile }}</a
          >
        </div>
      </div>
      <div class="bookingDetail mt-2">
        <h6 class="m-0 p-0">
          Booking ID #{{ paymentRetrievalHistory.bookingData.bookingId }}
          <a
            :href="
              'https://ontrack-operations.web.app/viewBooking/' +
              paymentRetrievalHistory.bookingData.id
            "
            class="btn-link m-0 p-0"
          >
            <b-icon icon="link"></b-icon>
          </a>
        </h6>
        <div class="d-flex m-0 p-0">
          <p class="m-0 p-0" style="font-size: 12px; color: gray">
            Duration:
            {{ paymentRetrievalHistory.bookingData.startDate | moment("LL") }}
            <span class="px-2">-</span>
          </p>
          <p class="m-0 p-0" style="font-size: 12px; color: gray">
            {{ paymentRetrievalHistory.bookingData.endDate | moment("LL") }}
          </p>
        </div>
      </div>
      <div class="retrievalPaymentHistory my-4 card py-3 p-2">
        <!-- {{ retrievalPaymentHistory }} -->
        <h6>Payment Ledger</h6>
        <div v-if="retrievalPaymentHistory.length > 0">
          <table class="table table-striped table-primary">
            <thead>
              <tr>
                <th class="">Amount Paid</th>
                <th class="">Waived off</th>
                <th class="">Balance</th>
                <th class="">Paymet Type</th>
                <th class="">Created On</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in retrievalPaymentHistory" :key="index">
                <td class="">{{ data.amount | currency}}</td>
                <td class="">{{ data.waivedOff | currency}}</td>
                <td class="">{{ data.balance | currency}}</td>
                <td class="">{{ data.paymentType }}</td>
                <td class="">{{ data.createdAt | moment("LL") }}</td>
                <td>
                    <span v-b-tooltip.hover :title="data.comment">
                        <b-icon icon="chat-left-dots"></b-icon>
                    </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="card py-4 text-center">No entries found.</div>
      </div>
    </div>
    <b-modal
      title="Adjust Ticket"
      centered
      scrollable
      hide-footer
      v-model="adjustPaymentToggler"
    >
      <div class="row m-0 p-0">
        <div class="col-md-12 col-12 my-2 p-2">
          <p class="m-0 p-0">Amount Received</p>
          <b-input v-model="paidAmount" type="number"></b-input>
          <p class="m-0 p-0" style="font-size: 12px; color: gray">
            Total amount received from the customer
          </p>
        </div>
        <div class="col-md-12 col-12 my-2 p-2">
          <p class="m-0 p-0">Waived Amount</p>
          <b-input v-model="waivedOff" type="number"></b-input>
          <p class="m-0 p-0" style="font-size: 12px; color: gray">
            Total amount waived off
          </p>
        </div>
        <div class="col-md-12 col-12 my-2 p-2">
          <p class="m-0 p-0">Payment Type</p>
          <b-form-select
            v-model="paymentType"
            :options="paymentOptions"
          ></b-form-select>
        </div>
        <div class="col-md-12 col-12 my-2 p-2">
          <p class="m-0 p-0">Comment</p>
          <b-textarea
            v-model="comment"
            placeholder="write your comment here"
            type="text"
          ></b-textarea>
          <p v-if="!comment" class="m-0 p-0" style="font-size: 12px; color: red">
            Comment is required
          </p>
        </div>
      </div>
      <hr />
      <b-alert variant="danger" dismissible v-model="error">
        <p> <b-icon icon="exclamation-triangle"></b-icon> {{errMessage}}</p>
      </b-alert>
      <b-button :disabled="!comment" block variant="primary" @click="adjustTicket"
        >Update Payment</b-button
      >
    </b-modal>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      paymentRetrievalId: "",
      adjustPaymentToggler: false,
      paymentOptions: [
        { value: null, text: "Not Paid" },
        { value: "Razorpay", text: "Razorpay", disabled: true },
        { value: "Cash", text: "Cash" },
        { value: "Others", text: "Others" },
      ],
      paidAmount: 0,
      paymentType: "Cash",
      waivedOff: 0,
      comment: "",
      error: false,
      errMessage: ''
    };
  },
  created() {
    this.paymentRetrievalId = this.$route.params.id;
    this.getTicket();
    this.getRetrievalPayment();
  },
  methods: {
    getTicket() {
      this.$store.dispatch("getTicketsById", { id: this.paymentRetrievalId });
    },
    getRetrievalPayment() {
      this.$store.dispatch("getRetrievalPaymentById", {
        id: this.paymentRetrievalId,
      });
    },
    adjustPayment() {
      this.adjustPaymentToggler = true;
    },
    adjustTicket() {
      var totalAmountPaid = Number(this.paidAmount) + Number(this.waivedOff)
      if (totalAmountPaid > this.paymentRetrievalHistory.amount) {
        this.error = true
        this.errMessage = 'Total of amount received and waived off cannot exceed total payable amount. Total payable amount is '+ this.paymentRetrievalHistory.amount +' and amount entered including waived off amount is '+ totalAmountPaid +'.'
      }
      else {
        var obj = {
        ticketId: this.paymentRetrievalId,
        amount: totalAmountPaid,
        paymentType: this.paymentType,
        paidOn: Date.now(),
        comment: this.comment,
        waivedOff: this.waivedOff,
        test: false,
        };
        this.$store.dispatch("adjustPaymentTickets", obj).then(() => {
          this.getTicket();
          this.getRetrievalPayment();
          this.adjustPaymentToggler = false;
        });
      }
    },
  },
  computed: {
    loading() {
      return this.$store.state.loading_api;
    },
    paymentRetrievalHistory() {
      return this.$store.state.paymentRetrievalHistoryById;
    },
    retrievalPaymentHistory() {
      return this.$store.state.retrievalPaymentHistoryHistoryById;
    },
    invalid() {
      if (
        this.obj.bookingId &&
        this.obj.address &&
        this.obj.comment &&
        this.amount > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.comment-container {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 5px;
}
</style>